import React from 'react';
import { TableRow, TableCell } from '@mui/material';

import { tableRowCellBorderRight } from '../../../styles/tables';

const ProviderReportsTableRow = ({
  id,
  provider,
  status,
  customers,
  Direct = { sent: 0, parts: 0 },
  Standard = { sent: 0, parts: 0 },
  Replies = { sent: 0, parts: 0 },
  Sent = { sent: 0, parts: 0 },
  users,
}) => (
  <TableRow key={'list' + id} id={id}>
    <TableCell name="provider">{provider}</TableCell>
    <TableCell align="right" name="status">
      {status}
    </TableCell>
    <TableCell align="right" name="customers">
      {customers}
    </TableCell>
    <TableCell align="right" sx={tableRowCellBorderRight} name="users">
      {users}
    </TableCell>
    <TableCell align="right" name="directMessages">
      {Direct.sent + ` (${Direct.parts})`}
    </TableCell>
    <TableCell align="right" name="standardMessages">
      {Standard.sent + ` (${Standard.parts})`}
    </TableCell>
    <TableCell align="right" sx={tableRowCellBorderRight} name="replies">
      {Replies.sent + ` (${Replies.parts})`}
    </TableCell>
    <TableCell align="right" name="reminders">
      {Sent.sent + ` (${Sent.parts})`}
    </TableCell>
  </TableRow>
);

export default ProviderReportsTableRow;
